import { rules } from './rules';

export const locale = {
  rulesHtml: rules,

  // Advice
  editAdvice: 'You can set a nickname and avatar by clicking on the pencil',

  //Auth
  userUpdateSuccess: 'Data updated!',
  userUpdateFail: 'An error has occurred. Please try a different nickname or update the data later.',

  //Chat
  online: 'Online',
  enterMessage: 'Enter your message',

  // Basket
  amount: 'Amount',
  startGame: 'Start game',
  autoPick: 'Auto pick',
  min: 'Min',
  max: 'Max',
  maxWin: 'Maximum win',
  cashout: 'Cashout',
  roundID: 'Round ID',
  betLimits: 'Bet limits',
  gameCompleted: 'You won! Collect your winnings!',
  chooseYourWay: 'Choose your way!',

  //Game
  placeBetSuccess: (amount, currency) => `Bet has been placed! ${amount} ${currency}`,
  tryAgain: 'Failure. Try again!',

  //History
  myBets: 'My bets',
  topWins: 'Tops wins',
  chat: 'Chat',
  betAmount: 'Bet amount',
  winAmount: 'Win Amount',
  youWon: 'Victory! Your winnings:',
  glassBridge: 'Glass Bridge',
  game: 'Game',
  placed: 'Placed',
  bet: 'Bet',
  win: 'Win',
  lose: 'Loss',
  promoList: 'Promo',
  noPromo: 'There is no promo right now',
  closePromo: 'get it',

  //Training
  dontShowAgain: 'Don’t show again',
  skip: 'Skip',
  trainingTitle1: 'INCREASE YOUR CHANCE TO PASS THE GLASS BRIDGE FULLY!',
  trainingTitle2: 'CHOOSE THE NUMBER OF GLASSES!',
  trainingTitle3: 'PLAY AND WIN X57000!',
  trainingText1: 'Choose a number from 1 to 24 and win your bet x24 times!',
  trainingText2: 'The more rows of glasses, the greater the gain!',
  trainingText3: `It's max possible odds, just do it!`,
  back: 'Back',
  next: 'Next',
  close: 'Close',

  // Settings
  sound: 'Sound',
  music: 'Music',

  // Jackpot
  won: 'won',
  anotherWinnerNotify: (winner_name, jackpot_name, winner_amount, currency) => `Player ${winner_name} won a ${jackpot_name} of ${winner_amount} ${currency}`,
  congratulations: 'Congratulations',
  youWonJackpot: `You've won`,

  //Rules
  rules: 'Rules',
  howToPlay: 'How to play?',
  detailedRules: 'Detailed rules',
  playNow: 'Play now',
  rule1: 'CHOOSE the number of players, choose the bet amount and start the game!',
  rule2: 'WATCH the multiplier grows with each correct move and your profit increases',
  rule3: 'MAKE A CASHOUT at any time and earn X times more!',

  //MegaWins 
  megaWinMega: 'Mega',
  megaWinWin: 'Win',

  //NewYear
  newYearTitle: 'HAPPY NEW YEAR!',
  player: 'player',
  text1: 'Dear',
  text2: 'We would like to congratulate you for spending this year with us.',
  text3: 'We hope you enjoyed every bet placed, and every possible win with our games. We are grateful to you for staying with FIABLE GAME.',
  text4: 'Therefore, we have collected for you interesting statistics for the past year.',
  statisticTitle: 'In 2023, together with FIABLE GAMES, you have:',
  statistic1: '• Won all of our games',
  statistic2: '• Claim your biggest win of',
  statistic3: '• Made as many as',
  statistic4: 'bets!',
  text5: 'We promise to delight you with new exciting games in the new 2024, huge wins and cool promotions!',
  text6: 'We wish you happiness, more gains and best of luck for next year!',
  text7: 'Thank you for staying with us, playing with us and winning with us!',
  text8: 'Sincerely, the administration and development team of your favourite casino provider.',
  fiableGames: 'FIABLE GAMES!',
};